import { forwardRef, useImperativeHandle } from "react";
import { ChoiceSelections, StepProps, StepRef } from "../types";
import ChoiceStep from "../components/ChoiceStep";
import {
  Briefcase,
  Gift,
  Heart,
  Home,
  Plane,
  Sparkles,
  Users,
} from "lucide-react";

export default forwardRef<StepRef, StepProps>(
  ({ onNext, signupState, disabled }: StepProps, ref) => {
    useImperativeHandle(ref, () => ({}));
    return (
      <ChoiceStep
        title={"What would you love to get off your plate?"}
        subtitle={
          "Choose anything you’d happily hand off. You can select multiple categories."
        }
        disabled={disabled}
        cardVariant="detailed"
        img="/assets/images/nux/join-goals.jpg"
        mobileImg="/assets/images/nux/join-goals.jpg"
        imageHeight="600px"
        buttonText="Now, help me find the perfect Advisor"
        choiceOptions={[
          {
            id: "maintenance",
            header: "Home & maintenance",
            text: "Contractors, repairs, cleaning, appointments",
            icon: <Home />,
          },
          {
            id: "family-admin",
            header: "Family admin",
            text: "Forms, scheduling, research, returns",
            icon: <Users />,
          },
          {
            id: "travel",
            header: "Travel & planning",
            text: "Flights, hotels, itineraries, points & miles",
            icon: <Plane />,
          },
          {
            id: "health",
            header: "Health & appointments",
            text: "Doctors, dentists, insurance, records",
            icon: <Heart />,
          },
          {
            id: "celebrations",
            header: "Celebrations & gifts",
            text: "Birthdays, holidays, gifts, parties",
            icon: <Gift />,
          },
          {
            id: "grow-business",
            header: "Work & business",
            text: "Scheduling, research, coordination, admin",
            icon: <Briefcase />,
          },
          {
            id: "everything",
            header: "Honestly, a little of everything",
            text: "I could use support across many areas",
            icon: <Sparkles />,
            fullWidth: true,
          },
        ]}
        onNext={async (choices: ChoiceSelections) => {
          await onNext?.({ goals: choices });
        }}
        initialChoices={signupState?.goals || undefined}
      />
    );
  },
);
